const SESSION_STORAGE_KEY = "authed.sessionId";

export function getStoredSessionId(): string | null {
  return window.localStorage.getItem(SESSION_STORAGE_KEY);
}

export function storeSessionId(sessionId: string): void {
  window.localStorage.setItem(SESSION_STORAGE_KEY, sessionId);
}

export function clearStoredSessionId(): void {
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
}

// Reads `#session=...` from the URL fragment if present, persists it, and
// rewrites the URL to remove the fragment. Returns the captured session ID,
// or null if no fragment was present.
export function captureSessionFromUrlFragment(): string | null {
  const fragment = window.location.hash.replace(/^#/, "");
  if (!fragment) {
    return null;
  }

  const params = new URLSearchParams(fragment);
  const sessionId = params.get("session");
  if (!sessionId) {
    return null;
  }

  storeSessionId(sessionId);
  window.history.replaceState(
    null,
    "",
    window.location.pathname + window.location.search,
  );
  return sessionId;
}
